import { useMemo } from 'react';
import useConfig from '@/hooks/use-config/index';
import useSubmittalsDataElements from '@/hooks/use-submittals/useSubmittalsDataElements';

const useSubmittalsVisibility = () => {
	const { dataElements, isSubmittalsEnabled } = useSubmittalsDataElements();
	const { provideItems } = useConfig();

	const showSubmittals = useMemo(() => {
		if (!isSubmittalsEnabled || !dataElements.length || !provideItems.length) return false;
		const produceIds = new Set(provideItems.map(item => item.id));
		return dataElements.some(de => produceIds.has(de.dataElementId));
	}, [isSubmittalsEnabled, dataElements, provideItems]);

	return { showSubmittals };
};

export default useSubmittalsVisibility;
